<template>
    <a-modal :title="'Scan to Print'"
             :visible="showWindows"
             width="40%"
             class="print_class"
             :maskClosable="false"
             :footer="null"
             :zIndex="99"
             @cancel="closeWindow">
        <a-row>
            <a-col :span="22" >
                <div style="display: flex; align-items: center;">
                    <!-- <a-col :span="4" > -->
                    <span style="font-size:14px;font-weight: bold;margin-right: 12px ">{{$t('orderRef')}}:</span>
                    <!-- </a-col> -->
                    <a-col :span="16" >
                        <a-input style="width: 100%;" v-model="orderNo" @keyup.enter="print($event)"/>
                    </a-col>
                    <a-col :span="3" >
                        <a-button type="primary" class="mg5" @click="print($event)">{{$t('pubGicSet.Print')}}</a-button>
                    </a-col>
                </div>
            </a-col>
        </a-row>
        <a-row>
            <a-col :span="20" >
                <div style="display: flex; align-items: center;">
                    <a-col :span="1" >
                        <a-checkbox size="small" v-model="isCheckedPrint"  @change="clickPrint"></a-checkbox>
                    </a-col>
                    <a-col :span="3" >
                        <span style="font-size:12px;font-weight: bold ">Print</span>
                    </a-col>
                </div>
            </a-col>
        </a-row>
        <a-row>
            <a-col :span="20" >
                <div style="display: flex; align-items: center;">
                    <a-col :span="1" >
                        <a-checkbox size="small"  v-model="isCheckedPdf" @change="clickPdf"></a-checkbox>
                    </a-col>
                    <a-col :span="3" >
                        <span style="font-size:12px;font-weight: bold ">PDF</span>
                    </a-col>
                </div>
            </a-col>
        </a-row>
    </a-modal>
</template>

<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import webSocketPrint from "./webSocketPrint";

    export default{
        components:{
        },
        data(){
            return{
                showWindows: false,
                isCheckedPrint:true,
                isCheckedPdf:false,
                orderNo:'',
                printMode: '0',
                ip:'',
                printers:[]
            }
        },
        methods:{
            isValidJSON(str) {
                try {
                    JSON.parse(str);  // 尝试将字符串解析为 JSON
                    return true;  // 如果解析成功，则是有效的 JSON
                } catch (e) {
                    return false;  // 如果解析失败，则不是有效的 JSON
                }
            },
            getPrinters(){
                let that = this;
                if ("WebSocket" in window)
                {
                    // Create websocket
                    var ws = new WebSocket("ws://localhost:9999/print");
                    ws.onopen = function()
                    {
                        ws.send("{'Type':'SERVER_INFO'}");
                    };
                    ws.onmessage = function (evt)
                    {
                        var msg = evt.data;
                        if (that.isValidJSON(msg)){
                            that.printers = JSON.parse(msg).printerServer.printers;
                        };
                    };
                    ws.onclose = function()
                    {

                    };
                }
            },
            show(){
                this.showWindows = true;
            },
            closeWindow() {
                this.showWindows = false;
                this.printMode = null;
                this.isCheckedPdf =false;
                this.isCheckedPrint = true;
                this.printMode = '0'
                this.orderNo = '';
            },
            clickPrint(){
                this.printMode = '0'
                this.isCheckedPdf =false
            },
            clickPdf(){
                this.printMode = '1'
                this.isCheckedPrint =false
            },
            print(event){
                this.getPrinters();
                let params = {};
                params.printMode = this.printMode;
                params.orderNo = this.orderNo;
                params.ip = this.ip;
                ajax.get(api.SCANTOPRINT,params).then(res=>{
                    if(res.code == 200){
                        let data =  res.data;
                        if('0' == this.printMode){
                            //  this.webSocketPrint(res.msg,"9999",'111')
                            for (let i = 0; i < data.length; i++) {
                                if (data[i] == null) {
                                    continue;
                                }
                                if (data[i].type == null) {
                                    continue;
                                }
                                if (data[i].errorMsg != null && data[i].errorMsg != "") {
                                    continue;
                                }
                                let printerName = "";
                                if (data[i].printerName == null || data[i].printerName == "") {
                                    continue;
                                }else {
                                    console.log("printerNames:"+data[i].printerName);
                                    let printerNames =  data[i].printerName.split(",");
                                    for(var j = 0;j<this.printers.length;j++){
                                        for(var k = 0;k<printerNames.length;k++){
                                            if(this.printers[j].name==printerNames[k]){
                                                printerName = printerNames[k];
                                                break;
                                            }
                                        }
                                        if(printerName!=""&&printerName!=null){
                                            break;
                                        }
                                    }
                                }
                                if(printerName != ""){
                                    data[i].printerName = printerName;
                                    this.webSocketPrint("9999",data[i],i,data.length,res.msg,event)
                                }
                            }
                        }else{
                            let urlList = data.split(",")
                            if (urlList == null || urlList.length == 0){
                                let  errorMsg = this.$t('notLabelRecord');
                                this.$customMessage.warning(errorMsg,3);
                                return;
                            }
                            for(let i = 0 ; i < urlList.length ; i++){
                                window.open(urlList[i]);
                            }
                            event.target.select();
                        }
                    }else{
                        this.$customMessage.warning(res.msg)
                        event.target.select();
                    }


                });
            },
            async webSocketPrint(port,data,index,dateLength,msg,event) {
                // console.info(index)
                // console.info(dateLength)
                try {
                    // 调用 connectSocket 函数，通过 async/await 处理异步操作
                    if(data.fileBytes.length > 125000){
                        let oldFileBytes = data.fileBytes;
                        let part = Math.ceil(oldFileBytes.length/125000);//分批数
                        for (let j = 0; j < part; j++)
                        {
                            let fileBytes = "";
                            if (oldFileBytes.length>125000) {
                                fileBytes = oldFileBytes.substring(0, 125000);
                                oldFileBytes = oldFileBytes.substring(125000, oldFileBytes.lenght);
                            } else {
                                fileBytes = oldFileBytes.substring(0, oldFileBytes.lenght);
                                oldFileBytes = "";
                            }
                            data.fileIndex = j;//当前发送位置
                            data.fileCount = part;//表示发送多次已发完
                            data.fileBytes = fileBytes;
                            await webSocketPrint.doPrint2(port, JSON.stringify(data));
                        }
                    }else{
                        data.fileCount =  1;//1表示一次发完
                        await webSocketPrint.doPrint2(port, JSON.stringify(data));
                    }
                    if(index == dateLength-1){
                        this.$message.success(msg);
                    }


                } catch (error) {
                    //   console.error('连接失败:', error);
                    let errorMsg;
                    if (error === 'PRINTER_NOT_CONNECTED') {
                        errorMsg = this.$t('printNotConnected');;
                    } else {
                        // errorMsg = '连接失败，请检查网络或服务器设置！';
                        errorMsg = error;
                    }
                    // 抛出异常
                    this.$customMessage.warning(errorMsg);
                }

            },
            // 获取用户本地ip的方法
            getUserIP (onNewIP) {
                let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
                let pc = new MyPeerConnection({
                    iceServers: []
                })
                let noop = () => {

                }
                let localIPs = {}
                let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g
                let iterateIP = (ip) => {
                    if (!localIPs[ip]) onNewIP(ip)
                    localIPs[ip] = true
                }
                pc.createDataChannel('')
                pc.createOffer().then((sdp) => {
                    sdp.sdp.split('\n').forEach(function (line) {
                        if (line.indexOf('candidate') < 0) return
                        line.match(ipRegex).forEach(iterateIP)
                    })
                    pc.setLocalDescription(sdp, noop, noop)
                }).catch((reason) => {
                })
                pc.onicecandidate = (ice) => {
                    if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return
                    ice.candidate.candidate.match(ipRegex).forEach(iterateIP)
                }
            },
        },
        mounted(){
            this.getUserIP((ip) => {
                this.ip = ip;
            });
        }
    }
</script>

<style>

    .print_class .ant-modal-title {
        font-size: 18px; /* 设置字体大小 */
        font-weight: bold; /* 设置字体加粗 */
    }
</style>